// All the useful bits of code copied from here:
// https://css-tricks.com/making-an-audio-waveform-visualizer-with-vanilla-javascript/

import { useEffect, useRef, useState } from "react";
import useComponentSize from "@rehooks/component-size";
import styles from "./waveformPlayer.module.css";

export const WaveformPlayer = ({
  currTime = 0,
  duration = 249,
  totalBars = 42,
  onClick,
  placeCanvas,
  waveformData = [
    0.4732823395588968, 0.5255197481593967, 0.507938253492122,
    0.6107032711864413, 0.5389065259292497, 0.5703459197979741,
    0.48796179874845347, 0.4739464266847539, 0.6223679839746447,
    0.41211840643179826, 0.6515505169479158, 0.6328244191294852,
    0.5127068935173967, 0.661565639951772, 0.579333763547303,
    0.5666481608363848, 0.4257084903543339, 0.6451773954400576,
    0.4053547810133391, 0.6776775842264315, 0.673034083056104,
    0.7681584891424728, 0.6284734995468241, 0.3814876320391671,
    0.590032197872528, 0.5505028878427545, 1, 0.7201452677348367,
    0.9691039492519941, 0.7871735099843631, 0.410423853972255,
    0.6110051860123035, 0.4185422459161361, 0.501499008942671,
    0.35727485116164376, 0.5758116597725593, 0.4247204322052231,
    0.5157616997612109, 0.47876980565732785, 0.43610093370741315,
    0.606815644298504, 0.4848491123489229,
  ],
}) => {
  const [maxBarHeight, setMaxBarHeight] = useState(100);
  const canvasRef = useRef(null);
  const canvasHolderRef = useRef(null);
  const size = useComponentSize(canvasHolderRef);

  useEffect(() => {
    if (!size.height || size.height === 0) return;

    if (size.height !== maxBarHeight) {
      setMaxBarHeight(size.height * 0.7);
    }
  }, [size.height, maxBarHeight]);

  useEffect(() => {
    if (!placeCanvas || !canvasRef.current) return;

    const canvas = canvasRef.current;
    canvas.width = 640;
    canvas.height = 452;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      placeCanvas,
      0,
      0,
      placeCanvas.width,
      placeCanvas.height,
      0,
      0,
      canvas.width,
      canvas.height
    );
  }, [placeCanvas, canvasRef]);

  const durationPerBar = duration / totalBars;
  return (
    <div className={styles.background}>
      <div className={styles.panel}>
        {/* <div className={styles.screen}> */}
        <div className={styles.canvasHolder} ref={canvasHolderRef}>
          <canvas ref={canvasRef} className={styles.photoCanvas} />
        </div>
        <div className={styles.waveform}>
          {waveformData &&
            waveformData.map((wd, i) => (
              <Bar
                key={i}
                size={wd}
                index={i}
                onClick={onClick}
                currTime={currTime}
                maxBarHeight={maxBarHeight}
                durationPerBar={durationPerBar}
              />
            ))}
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

const Bar = ({
  currTime,
  durationPerBar,
  size,
  index,
  onClick,
  maxBarHeight,
}) => {
  const barStartTime = durationPerBar * index;
  const barEndTime = barStartTime + durationPerBar;
  const hasBeenPlayed = barEndTime <= currTime;
  const isBeingPlayed = currTime > barStartTime && currTime < barEndTime;
  let currBarDuration = 0;
  if (isBeingPlayed) {
    currBarDuration = (currTime - barStartTime) / durationPerBar;
  }

  const onBarClick = () => onClick(barStartTime + durationPerBar / 2);

  const background = hasBeenPlayed
    ? "rgba(18,193,40,0.9)"
    : "rgba(224,34,0,0.6)";
  const fullBarHeight = size * maxBarHeight; //224 134 0

  return (
    <div
      className={styles.barHolder}
      style={{ height: maxBarHeight }}
      onClick={onBarClick}
    >
      <div
        className={styles.bar}
        style={{ height: fullBarHeight, background }}
      />
      {isBeingPlayed && (
        <div className={styles.barOverHolder}>
          <div
            className={styles.barOver}
            style={{ height: currBarDuration * fullBarHeight }}
          />
        </div>
      )}
    </div>
  );
};
